import { Applicant } from '../customer/Applicant';
import { Person } from '../customer/Person';
import { Product } from '../static/Product';

const _BusinessRules: any = {
  CAS: {
    AgeRange: {
      value1: '18',
      value2: '60',
      value3: '65',
    },
    FaceLimit: {
      value1: '100000',
      value2: '1000000',
      value3: '2000000',
    },
    AllowedTerm: {
      value1: '10',
      value2: '20',
    },
    ConvertibilityAgeLimit: {
      value1: '18',
      value2: '55',
      value3: '65',
    },
  },
};

// MMDirect's business logic should copy that of Coverpath
_BusinessRules.MMDirect = _BusinessRules.CAS;

export interface DocsNeeded {
  [docsGroupKey: string]: {
    Insured: InsuredDocsConditionsMap;
    Owner: OwnerDocsConditionsMap;
  };
}

export interface InsuredDocsConditionsMap {
  [docName: string]: (insured: Applicant) => boolean;
}

export interface OwnerDocsConditionsMap {
  [docName: string]: (ownerPerson: Person) => boolean;
}

export interface DocsList {
  Insured: Array<string>;
  Owner: Array<string>;
}

export const BusinessRules = _BusinessRules;
